class SmbQuoteFunnel {
  constructor(root) {
    this.root = root;
    this.modal = root.querySelector('[data-smb-modal]');
    this.steps = [...root.querySelectorAll('[data-smb-step]')];
    this.progress = [...root.querySelectorAll('[data-smb-progress]')];
    this.form = root.querySelector('#SmbQuoteForm');
    this.current = 0;
    root.querySelectorAll('[data-smb-open]').forEach((button) => button.addEventListener('click', () => this.open()));
    root.querySelectorAll('[data-smb-close]').forEach((button) => button.addEventListener('click', () => this.close()));
    root.querySelector('[data-smb-next]')?.addEventListener('click', () => this.next());
    root.querySelector('[data-smb-back]')?.addEventListener('click', () => this.back());
    this.modal?.addEventListener('click', (event) => { if (event.target === this.modal) this.close(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && this.modal?.classList.contains('is-open')) this.close(); });
    if (root.querySelector('.smb-success.is-active, .smb-form-errors')) {
      if (root.querySelector('.smb-form-errors')) this.current = this.steps.length - 1;
      if (this.steps.length) this.update();
      this.open();
    }
  }
  open() { this.modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  close() { this.modal.classList.remove('is-open'); document.body.style.overflow = ''; }
  update() {
    this.steps.forEach((step, index) => step.classList.toggle('is-active', index === this.current));
    this.progress.forEach((item, index) => item.classList.toggle('is-active', index <= this.current));
    this.root.querySelector('[data-smb-back]').hidden = this.current === 0;
    this.root.querySelector('[data-smb-next]').textContent = this.current === this.steps.length - 1 ? 'Send my project →' : 'Continue →';
  }
  next() {
    const required = [...this.steps[this.current].querySelectorAll('[required]')];
    const invalid = required.find((field) => !field.checkValidity());
    if (invalid) { invalid.reportValidity(); return; }
    if (this.current < this.steps.length - 1) { this.current += 1; this.update(); return; }
    this.form?.requestSubmit();
  }
  back() { if (this.current > 0) { this.current -= 1; this.update(); } }
}
document.querySelectorAll('[data-smb-home]').forEach((root) => new SmbQuoteFunnel(root));
